import { Injection } from '../../../types/utils';
import { DataViewFiltersUtilsInjection } from './DataViewFilters.types';

// See: https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject

export const DATA_VIEW_FILTERS_UTILS_INJECTION: Injection<DataViewFiltersUtilsInjection> = Object.freeze({
  key: Symbol('DATA_VIEW_FILTERS_UTILS_INJECTION_KEY'),
});
